import {StateProvider} from "@uirouter/angularjs";
import {UserConfigProvider} from "../types/UserConfig";
import {Branding} from "../types/Branding";
import {IvStoreService} from "./iv/services/IvStoreService";
import {IvStoreViewStore} from "./iv/services/IvStoreViewStore";
import {UserStripeService} from "../stripe/service/UserStripeService";
import {IInjectable} from "@uirouter/core";
import {IInvestStoreViewStore} from "./iinvest/service/IInvestStoreViewStore";
import {IInvestStoreService} from "./iinvest/service/IInvestStoreService";
import {StoreViewStore} from "./common/services/StoreViewStore";
import {TfStoreService} from "./tf/services/TfStoreService";
import {TfStoreViewStore} from "./tf/services/TfStoreViewStore";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {
    const branding = userConfigProvider.config.branding;

    if (branding === Branding.IV) {
        configureStore($stateProvider, "ivStoreView", ivViewStoreResolver);
    } else if (branding === Branding.IINVEST) {
        configureStore($stateProvider, "iinvestStore", iinvestViewStoreResolver);
    } else if (branding === Branding.TF) {
        configureStore($stateProvider, "tfStoreView", tfViewStoreResolver);
    }
}

function configureStore($stateProvider: StateProvider, component: string, resolver: IInjectable) {
    $stateProvider.state("store", {
        url: "/store?product&returnTo",
        component,
        resolve: {
            viewStore: resolver
        },
        data: {
            pageTitle: "Store"
        },
        params: {
            product: null,
            returnTo: null
        },
        onExit: cleanUp
    });
}

/** @ngInject */
export function ivViewStoreResolver(ivStoreService: IvStoreService,
                                    userStripeService: UserStripeService): IvStoreViewStore {
    return IvStoreViewStore.initialize(ivStoreService, userStripeService);
}

/** @ngInject */
export function iinvestViewStoreResolver(iinvestStoreService: IInvestStoreService,
                                         userStripeService: UserStripeService): IInvestStoreViewStore {
    return IInvestStoreViewStore.initialize(iinvestStoreService, userStripeService);
}

/** @ngInject */
export function tfViewStoreResolver(tfStoreService: TfStoreService,
                                    userStripeService: UserStripeService): TfStoreViewStore {
    return TfStoreViewStore.initialize(tfStoreService, userStripeService);
}

/** @ngInject */
export function cleanUp(viewStore: StoreViewStore<any>) {
    viewStore.destroy();
}
